import { render, staticRenderFns } from "./HorizontalSellingList.vue?vue&type=template&id=7db12c16"
import script from "./HorizontalSellingList.vue?vue&type=script&lang=js"
export * from "./HorizontalSellingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports